<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="1300"
    offset-y
    style="margin-top:200px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn style="border-radius: 20px;margin-right:20px;margin-top:-10px"        
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <!-- <v-list-item-avatar>
            <img
              src="https://cdn.vuetifyjs.com/images/john.jpg"
              alt="John"
            >
          </v-list-item-avatar> -->

          <v-list-item-content>
            <v-text-field
              v-model="search"
              append-icon="mdi-search"
              :label="$t('common.search')"
              singleLine
              hideDetails
              @input="handleSearch"
            />
          </v-list-item-content>

          <v-list-item-action>
            <v-btn
              icon
              @click="menu = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider />
      <v-data-table
        v-if="search && search.length > 0 && searchResult && searchResult.length > 0"
        style="margin-top: 0;margin-left:5px;margin-right:5px;"
        :headers="headers"
        :items="searchResult"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.serial`]="{ item }">
          <description-form  :key="`inci_${item.serial}`" v-if="isEditDescription" :item="item" />
          <span v-else>{{ item.serial}}</span>
        </template>
        <template v-slot:[`item.network`]="{ item }">
          <v-chip style="width:100%" small :color="getColor(item.network)" dark><center style="width=100%">{{ item.network }}</center></v-chip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div style="width:80px">
          <v-icon :style="{ 'color' : item.status === 'Error' ? '#D32F2F' : '#7CB240'}">{{item.status === 'Error' ? 'mdi-alert-box' : 'mdi-checkbox-marked'}}</v-icon>
          <v-icon :style="{ 'color' : item.statusColor.color}">{{item.statusColor.icon}}</v-icon>
          <v-icon :style="{ 'color' : item.downloadError? '#D32F2F' : '#7CB240'}">mdi-download-network</v-icon>
          </div>
        </template>
        <template v-slot:[`item.lctime`]="{ item }">
          <div style="width:150px">
            {{convertTime(item.lctime)}}
          </div>
        </template>
        
      </v-data-table>
      <!-- <v-list>
        <v-list-item>
          <v-list-item-action>
            <v-switch
              v-model="message"
              color="purple"
            ></v-switch>
          </v-list-item-action>
          <v-list-item-title>Enable messages</v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-action>
            <v-switch
              v-model="hints"
              color="purple"
            ></v-switch>
          </v-list-item-action>
          <v-list-item-title>Enable hints</v-list-item-title>
        </v-list-item>
      </v-list> -->

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="menu = false"
        >
          {{$t('common.close')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import DescriptionForm from './DescriptionForm'
  import utils from '@/services/utils'
  export default {
    components: {
      DescriptionForm
    },
    props: {
      onSearch: {
        search: '',
        type: Function,
        required: false,
        default: null
      },
      searchResult: {
        type: Array,
        required: false,
        default: null
      }
    },
    data: () => ({
      menu: false,
      message: false,
      hints: true,
      search: '',
      headers: [
          {
            text: 'Network',
            align: 'start',
            value: 'network',
          },
          { text: 'Unit ID', value: 'serial' },
          { text: 'Nombre', value: 'name' },
          { text: 'Grupo', value: 'group_name' },
          { text: 'Status', value: 'status', sortable: false },
          { text: 'Descripción', value: 'description' },
        ],
    }),
    computed: {
      isEditDescription () {
        return false //process.env.VUE_APP_ENV === 'development'
      },
    },
    watch: {
      searchResult (newValue) {
      }
    },
    created () {
      this.items = this.data
      this.handleSearch = _.debounce(() => {
        this.onSearch(this.search)
      }, 500)
    },
    methods: {
      getColor (value) {
        return utils.getColor(value)
      },
      getStatus (value) {
        return utils.getStatus(value)
      },
      getDownloadStatus (value) {
        return utils.getDownloadStatus(value)
      },
      convertTime(value) {
        const dt = new Date(value)
        const result = `${
                dt.getDate().toString().padStart(2, '0')}/${
                (dt.getMonth()+1).toString().padStart(2, '0')}/${
                dt.getFullYear().toString().padStart(4, '0')} ${
                dt.getHours().toString().padStart(2, '0')}:${
                dt.getMinutes().toString().padStart(2, '0')}:${
                dt.getSeconds().toString().padStart(2, '0')}`

        return result === '01/01/0001 00:00:00' ? '' : result
      }
    }
  }
</script>